import { useLang } from '@/i18n';
import EfIcon from '@elem/ui/ef-icon';

export default function TheComp() {
    const { t } = useLang('theProduct.HighlightsA');
    return (
        <>
            <div className="card-box card-box7 card-box-bottom">
                <EfIcon className="card-icon" pc="https://websiteoss.ecoflow.com/upload/image/1723725240623/b1.png" />
                <div className="card-desc">{t('item7_title')}</div>
            </div>
        </>
    );
}
